import { render, staticRenderFns } from "./TagCreateUpdate.vue?vue&type=template&id=29a39940&"
import script from "./TagCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TagCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports